import {FC, SetStateAction, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Button} from '../../../../components/Button/Button'
import Swal from 'sweetalert2'
import {GET, PATCH, POST, PUT} from '../../../../services/api'
import {Input} from '../../../../components/Input/Input'
import {Loading} from '../../../../components/Loading/Loading'
import {useNavigate, useParams} from 'react-router-dom'
import {i18n} from '../../../../translate/i18n'
import {DragDropContext, Droppable, Draggable, DropResult} from 'react-beautiful-dnd'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'

const EditarGradesHotelFeedBackContent: FC = () => {
  const navigate = useNavigate()
  const {id} = useParams()
  const [loading, setLoading] = useState(false)
  const [title, setTitle] = useState('')
  const [variation, setVariation] = useState('')
  const [status, setStatus] = useState<boolean>(false)
  const [list, setList] = useState<string[]>([])

  const addList = () => {
    const newList = list
    newList.unshift(variation)
    setVariation('')
    setList(newList)
  }

  const removeList = (variationPosition: number) => {
    const newList = list.filter((variationFiltered, index) => variationPosition !== index)
    setVariation('')
    setList(newList)
  }

  const editGrid = async () => {
    try {
      if (!title || list.length === 0) {
        Swal.fire({
          icon: 'warning',

          title: i18n.t(`gridHotelFeedback.missing_fields`) as string,

          text: i18n.t(`gridHotelFeedback.missing_fields_message`) as string,
        })
      } else {
        setLoading(true)

        const gridRes = await PATCH(`/grid-hotel-feedback/${id}`, {
          title,

          content: {config: list},

          status,
        })

        setLoading(false)

        if (gridRes.success === true) {
          Swal.fire({
            icon: 'success',

            title: i18n.t(`gridHotelFeedback.grid_updated`) as string,

            text: i18n.t(`gridHotelFeedback.grid_updated_message`) as string,
          }).then(() => navigate('/hospitality/feedback-satisfaction/grid-hotel-feedback'))
        } else {
          Swal.fire({
            icon: 'error',

            title: i18n.t(`gridHotelFeedback.error`) as string,

            text: i18n.t(`gridHotelFeedback.error_update_message`) as string,
          })
        }
      }

      return
    } catch (e) {
      setLoading(false)

      console.log(e)

      Swal.fire({
        icon: 'error',

        title: i18n.t(`gridHotelFeedback.error`) as string,

        text: i18n.t(`gridHotelFeedback.error_update_message`) as string,
      })
    }
  }

  const getGridFeedBack = async () => {
    try {
      setLoading(true)

      const gridRes = await GET(`/grid-hotel-feedback/${id}`)

      setTitle(gridRes.data.title)

      setStatus(gridRes.data.status)

      const content =
        typeof gridRes.data.content === 'string'
          ? JSON.parse(gridRes.data.content)
          : gridRes.data.content

      const listVariation: string[] = content.config

      setList(listVariation)

      setLoading(false)
    } catch (e) {
      setLoading(false)

      console.log(e)
    }
  }

  const onDragEnd = (res: DropResult, list: any, setList: any) => {
    if (!res.destination) return

    const {source, destination} = res

    const copiedItems = [...list]

    const [removed] = copiedItems.splice(source.index, 1)

    copiedItems.splice(destination.index, 0, removed)

    setList(copiedItems)
  }

  useEffect(() => {
    getGridFeedBack()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`gridHotelFeedback.edit_service_grid`)}
                </span>

                <BreadCrumbs />

                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(`gridHotelFeedback.save_changes_edit`)}
                </span>
              </h3>
            </div>

            <div className='card-body'>
              <div className='card-body border-bottom'>
                <div className='d-flex justify-content-between align-items-center flex-wrap gap-5'>
                  <div className='flex-grow-1'>
                    <Input
                      inputAttr={{
                        type: 'string',
                      }}
                      placeholder={i18n.t(`gridHotelFeedback.service_grid_name_placeholder`)}
                      label={i18n.t(`gridHotelFeedback.service_grid_name`)}
                      change={(value: string) => setTitle(value)}
                      value={title}
                      onlyLetters={true}
                      marginTop='0'
                      maxCaracteres={30}
                    />
                  </div>

                  <div className='flex-grow-1'>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      value={status}
                      change={setStatus}
                      label={i18n.t(`gridHotelFeedback.general.active`)}
                      options={[
                        {select: i18n.t(`gridHotelFeedback.general.active`), value: true},

                        {select: i18n.t(`gridHotelFeedback.general.inactive`), value: false},
                      ]}
                      marginTop='0'
                    />
                  </div>
                </div>

                <div className='form-group mt-5'>
                  <label className='form-label fw-normal'>
                    {i18n.t(`gridHotelFeedback.service_list`)}
                  </label>

                  <div className='input-group'>
                    <input
                      type='text'
                      className='form-control fw-normal'
                      placeholder={i18n.t(`gridHotelFeedback.service_placeholder`)}
                      value={variation}
                      onChange={(event) => {
                        setVariation(event.target.value)
                      }}
                    />

                    <div className='input-group-append'>
                      <button
                        className='btn btn-success'
                        style={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}
                        type='button'
                        onClick={() => addList()}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>

                <DragDropContext onDragEnd={(result) => onDragEnd(result, list, setList)}>
                  <Droppable droppableId='ROOT' type='group'>
                    {(provided, snapshot) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {list.map((variationListed, index) => (
                          <Draggable key={index} draggableId={index.toString()} index={index}>
                            {(provided) => (
                              <div
                                className='form-group mt-5'
                                key={index}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <div className='input-group'>
                                  <button className='btn btn-sm btn-dark' disabled>
                                    <i className='bi bi-arrows-move'></i>
                                  </button>

                                  <input
                                    type='text'
                                    className='form-control fw-normal'
                                    placeholder={i18n.t(`gridHotelFeedback.service_placeholder`)}
                                    value={variationListed}
                                    onChange={(event) => {
                                      const newList = [...list]

                                      newList[index] = event.target.value

                                      setList(newList)
                                    }}
                                  />

                                  <div className='input-group-append'>
                                    <button
                                      className='btn btn-danger'
                                      style={{borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}
                                      type='button'
                                      onClick={() => removeList(index)}
                                    >
                                      -
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>

              <div className='d-flex w-100'>
                <div className='col-6 d-flex justify-content-start'>
                  <Button
                    text={i18n.t(`gridHotelFeedback.buttons.back`)}
                    color='info'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => navigate(-1)}
                    btnClass='fw-bolder m-9'
                  />
                </div>

                <div className='col-6  d-flex justify-content-end'>
                  <Button
                    text={i18n.t(`gridHotelFeedback.buttons.save`)}
                    color='primary'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => editGrid()}
                    btnClass='fw-bolder m-9'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const EditarGradesHotelFeedBack: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: i18n.t(`gridHotelFeedback.dashboard`) as string,
            path: 'dashboard',
            isActive: true,
          },

          {title: i18n.t(`gridHotelFeedback.service_grid`) as string, path: 'grid', isActive: true},

          {
            title: i18n.t(`gridHotelFeedback.general.edit`) as string,
            path: 'grid/editar',
            isActive: true,
          },
        ]}
      >
        {i18n.t(`gridHotelFeedback.service_grid`)}
      </PageTitle>

      <EditarGradesHotelFeedBackContent />
    </>
  )
}

export {EditarGradesHotelFeedBack}
